<template>
  <div class="investigator-lib w-full h-full box-border flex">
    <div
      class="h-full m-4"
      :class="showDygcFooter ? 'mb-0' : ''"
      :style="`width: calc(100% - 290px - 32px);height: calc(100% - ${showDygcFooter ? '16px' : '32px'})`">
      <div class="card">
        <div class="card-body" :class="showDygcFooter ? '' : 'h-full'">
          <ul class="mb-5 border-b border-solid" style="border-color: #e7e9eb">
            <router-link
              v-for="menu in menus"
              tag="li"
              :to="menu.path"
              :key="menu.meta.id"
              class="cursor-pointer leading-22 text-theme-black-650 text-medium inline-block px-10 py-3"
            >
              <div class="relative">
                {{ menu.meta.label }}
                <div v-if="menu.meta.badge" class="meta-badge">
                  <!-- 标签显示 -->
                  {{ menu.meta.badge }}
                </div>
              </div>
            </router-link>
          </ul>

          <div class="main-box w-full pl-5 pr-5 box-border" style="height: calc(100% - 69px); overflow: auto">
            <router-view></router-view>
          </div>
        </div>
        <!-- 网站协议文案提示 -->
        <DygcFooter class="my-2" v-custom:investigator-lib="'out_D30_D'" />
      </div>
    </div>

    <!-- 右半部分 -->
    <el-scrollbar wrapClass="overflow-x-hidden" class="w-290px h-full">
      <el-card class="min-h-full border-0 rounded-none" shadow="never">
        <div class="title text-medium-x leading-22 font-semibold ml-6 mr-4 mt-6 mb-2 text-theme-black-850">调查员库</div>
        <p v-if="isPersonal" class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          调查员库显示的是您个人所有的调查员信息，您可在项目中为调查员配面对面访问、电话调查、明察暗访等执行任务。
        </p>
        <p v-else class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          调查员库显示的是当前企业所有的调查员，您可在项目中为调查员分配面对面访问、电话调查、明察暗访等执行任务。
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          如需更多调查员，您可通过
          <span class="cursor-pointer text-theme" @click="toTaskSquare">任务广场</span>
          面向全国招募调查员
        </p>
        <div class="md:w-auto h-px bg-border-gray ml-6 mr-4"></div>

        <div class="title text-medium-x leading-22 font-semibold ml-6 mr-4 mt-6 mb-2 text-theme-black-850">委托执行</div>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 text-theme-black-850 flex">
          <span v-custom="'out_D74'">调研工厂</span>团队有超过 10 年的执行经验，承接明察暗访、网络调查、面对面访问等执行任务。
        </p>
        <p class="text-medium-x leading-24 font-medium pt-2 pb-1 ml-6 mr-4 text-theme-black-850 flex">我们的优势：</p>
        <p class="advantage">
          <i class="el-icon-success"></i>
          <span>我们自有或第三方共建执行团队超 5000 人</span>
        </p>
        <p class="advantage">
          <i class="el-icon-success"></i>
          <span>执行团队人员覆盖全国所有省份</span>
        </p>
        <p class="advantage">
          <i class="el-icon-success"></i>
          <span>执行团队成员至少拥有 2 年执行经验</span>
        </p>
        <p class="advantage">
          <i class="el-icon-success"></i>
          <span>在城市管理、公共服务、社会调查、文化旅游、资源环境等领域已成功超过执行 20000 个项目</span>
        </p>
        <p class="advantage">
          <i class="el-icon-success"></i>
          <span>您无需自建团队，成本大大降低</span>
        </p>
        <p class="advantage mt-1 mb-3">……</p>
        <div class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          更多细节，请查看
          <span class="cursor-pointer text-theme" @click="jumpIntroduce">委托执行介绍</span>
          <div>如需咨询，请扫码添加客服咨询</div>
          <div class="w-full box-border flex items-center pt-2 pb-4">
            <img src="/assets/img/code/Mrs.Chai.png" class="w-w-22 h-h-22" />
            <div class="ml-3 flex-1 text-small">
              <p class="w-full leading-22">
                <span class="text-theme-black-450">客服顾问：</span>
                <span class="text-theme-black-850">柴女士</span>
              </p>
              <p class="w-full leading-22">
                <span class="text-theme-black-450">联系电话：</span>
                <span class="text-theme-black-850">18511821229</span>
              </p>
            </div>
          </div>
        </div>
      </el-card>
    </el-scrollbar>
  </div>
</template>

<script>
import { toTaskSquare } from '@/assets/js/base-platform'
import { toUrl } from '@/assets/js/base-platform.js'
import GlobalConfig from '@/global/config'
import { mapGetters } from 'vuex'
import DygcFooter from 'components/dygc-footer-bottom/index'
import { getBaseDomain, getDomain } from '@/assets/js/config/env'

export default {
  name: 'InvestigatorLib',
  components: { DygcFooter },
  data() {
    return {
      qrSrc: process.env.VUE_APP_OFFICIAL_ACCOUNT_QR_CODE
    }
  },
  computed: {
    ...mapGetters(['configContextMap']),
    showDygcFooter() {
      let config = this.configContextMap.get("investigator-lib")?.out_D30_D
      return config ? config === "1" : true
    },
    isPersonal() {
      if (GlobalConfig.getCompanyId() == 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // 跳转到任务广场
    toTaskSquare,
    toDCY() {
      toUrl(getDomain() + '/visitor', {
        token: GlobalConfig.getBaseToken(),
        pageType: 1
      })
    },
    jumpIntroduce() {
      window.open(getBaseDomain() + `/entrustexe`)
    }
  },
  created() {
    this.menus = this.$dygcRouter.getChildrenByName('investigator-lib')
  }
}
</script>
<style lang="scss" scoped>
$badge: #e34152;
.investigator-lib {
  .router-link-active {
    @apply text-theme border-theme border-b-2 border-solid;
  }

  .card {
    @apply shadow-theme rounded h-full;
    .card-body {
      @apply overflow-auto bg-white;
    }
  }
}
.title::before {
  content: '';
  @apply bg-theme block float-left w-1 h-5 -ml-6;
  margin-top: 1px;
}
::v-deep .el-card__body {
  @apply p-0;
}
::v-deep .el-scrollbar__view {
  @apply h-full;
}
.jump {
  @apply text-theme cursor-pointer;
}
.meta-badge {
  @apply absolute px-1 py-px;
  right: -50px;
  top: -4px;
  height: 12px;
  line-height: 12px;
  font-size: 10px;
  border: 1px solid $badge;
  border-radius: 4px;
  color: $badge;
  // transform: translate(100%, -20%);
  transform: scale(0.73);
}
.advantage {
  @apply ml-6 mr-4 mb-2 leading-24 text-theme-black-850 text-medium font-normal flex;
  i {
    @apply text-small text-green-theme mr-1 leading-24 mt-px;
  }
}
</style>
